import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { QuestionType } from '@proxy/questions';
import { AppBaseComponent } from 'src/app/shared/app-base.component';
import { EnumDescriptor } from 'src/app/shared/enum-descriptor';

@Component({
    selector: 'app-question-type-dropdown',
    templateUrl: './question-type-dropdown.component.html',
    standalone: false
})
export class QuestionTypeDropdownComponent  extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() questionType: QuestionType;

  @Output() changeQuestionType = new EventEmitter<QuestionType>();

  questionTypes: EnumDescriptor[];

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.isNullOrUndefined(this.questionTypes)) {
      this.questionTypes = undefined;
    }

    this.loadQuestionType();
    this.onSelected();
  }

  loadQuestionType(): void {
    this.questionTypes = this.getEnumOptions(QuestionType, false);
  }

  onSelected(): void {
    this.changeQuestionType.emit(this.questionType);
  }
}
